document.addEventListener('DOMContentLoaded', function () {
  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';

  function reloadPage() {
    window.location.reload();
  }

  // Quote quantity stepper + remove (quote page)
  function changeLine(line, qty, el) {
    if (el) el.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () { reloadPage(); })
      .catch(function (err) { console.error(err); if (el) el.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-ca-step]');
    if (stepBtn) {
      var wrap = stepBtn.closest('.ca-step');
      var cur = parseInt(wrap.getAttribute('data-qty'), 10) || 0;
      var next = Math.max(0, cur + parseInt(stepBtn.getAttribute('data-ca-step'), 10));
      changeLine(parseInt(wrap.getAttribute('data-line'), 10), next, wrap);
      return;
    }
    var rm = e.target.closest('[data-ca-remove]');
    if (rm) {
      changeLine(parseInt(rm.getAttribute('data-ca-remove'), 10), 0, rm.closest('.ca-row'));
    }
  });

  // Add to Quote: add the item, then go straight to the quote page
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () { window.location.href = cartUrl; })
        .catch(function (err) {
          console.error('Add to quote failed', err);
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; }
        });
    });
  });

  // Generic header dropdowns
  var dropdowns = document.querySelectorAll('.dropdown-nav');
  dropdowns.forEach(function (dd) {
    var trigger = dd.querySelector('.dropdown-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !dd.classList.contains('open');
      dropdowns.forEach(function (other) {
        other.classList.remove('open');
        var t = other.querySelector('.dropdown-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) { dd.classList.add('open'); trigger.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', function (e) {
    dropdowns.forEach(function (dd) {
      if (!dd.contains(e.target)) {
        dd.classList.remove('open');
        var t = dd.querySelector('.dropdown-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(function (dd) {
        dd.classList.remove('open');
        var t = dd.querySelector('.dropdown-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });
});
